<template>
  <div class="">
    <vue-headful
      title="404 | Страница не найдена | Zinderland"
    />
    <div :class="ThemeGet" class="content__module d-f flex-column">
      <span class="h1 mb-1">Ошибка <b>404</b></span>
      <p class="h3">Страницы по данному запросу не существует</p>

      <router-link class="small-trans t-dd" to="/">Вернуться на главную</router-link>
    </div>

  </div>
</template>

<script>
  export default {
    name: "NotFoundPage",
    computed: {
      ThemeGet: function () {
        return this.$store.getters.ThemeGet;
      },
    },
  }
</script>
